import { Card, Button } from "antd";
import React from "react";
import { StopTwoTone } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

const UnAuthorized = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <StopTwoTone style={{ fontSize: "50px" }} twoToneColor={"red"} />
      <h1>Un-Authorized</h1>
      <p>
        Please{" "}
        <span>
          <Link to="/signin">Login</Link>
        </span>{" "}
        again.
      </p>

      <Button
        onClick={() => {
          logout();
          navigate("/signin");
        }}
      >
        Signout
      </Button>
    </div>
  );
};

export default UnAuthorized;
